import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {Registration} from "../../models/registration";
import {DeterminantService} from "../../services/registration-controller/determinant.service";
import {Store} from "../../services/store.service";

@Component({
  selector: "determinant-builder-section",
  templateUrl: "./determinant-builder-section.component.html",
})
export class DeterminantBuilderSectionComponent implements OnInit, OnDestroy  {
  @Input() public serviceId: string;
  @Input() public regDeterminant: any;
  public jsonString: string = "";
  public registration: Registration;
  public type: string;
  public selectedDeterminant: any;
  public listToggle: boolean = false;
  public sectionTitle: string = "";
  @Output() public editCancel = new EventEmitter();
  @Output() public editSave = new EventEmitter();
  public subscription: any;

  constructor(public store: Store,
              public determinantService: DeterminantService) {
  }

  public ngOnInit() {
    console.log("Determinant Builder Section Data: ", this.regDeterminant);
      this.serviceId = this.regDeterminant.serviceId;
      this.registration = this.regDeterminant.registration;
      this.type = this.regDeterminant.type;
      this.sectionTitle = this.regDeterminant.type === "mandatoryJsonDeterminants" ? "Edit Mandatory Determinant" : "Edit Optional Determinant";
      this.jsonString = this.regDeterminant.jsonString;
  }

  public ngOnDestroy() {
    // this.subscription.unsubscribe();
  }

  public closeLayer() {
    this.jsonString = "";
    this.editCancel.emit({cancel: true});
  }

  public closeEdit() {
    this.store.state.common.determinantSection.reset();
  }

  public setListView(b: boolean) {
    this.listToggle = b;
  }

  public onSave() {
    // this.registration[this.type] = jsonString;
    // this.determinantService.registration = this.registration;
    // this.determinantService.initDeterminant();
    this.editSave.emit({jsonString: this.jsonString, type: this.type});
    this.closeLayer();
  }

  public change(jsonString: any) {
    console.log("change", jsonString);
    if (typeof (jsonString) === "string") {
      this.jsonString = jsonString;
    }
    else if (jsonString && typeof (jsonString) === "object") {
      this.jsonString = jsonString.jsonString;
    }
  }
}
